<div class="cond-group" [ngClass]="{'child': removable}">
  <div class="d-flex justify-content-between">
    <div class="btn-group">
      <label class="btn btn-sm" [ngClass]="{'btn-primary': group.operator==='&&', 'btn-secondary': group.operator==='||'}" (click)="group.operator='&&'; groupChange.emit(group)">UND</label>
      <label class="btn btn-sm" [ngClass]="{'btn-primary': group.operator==='||', 'btn-secondary': group.operator==='&&'}" (click)="group.operator='||'; groupChange.emit(group)">ODER</label>
    </div>
    <div class="btn-group">
      <label type="button" class="btn btn-sm btn-success ml-2" *ngIf="!removable && canSave()" disabled>
        <i class="fa fa-check"></i>
      </label>
      <label type="button" class="btn btn-sm btn-danger ml-2" *ngIf="!removable && !canSave()" disabled>
        <i class="fa fa-times"></i>
      </label>
      <label class="btn btn-sm btn-primary" (click)="addGroup()"><i class="fa fa-plus"></i> Gruppe</label>
      <label class="btn btn-sm btn-primary" (click)="addRule()"><i class="fa fa-plus"></i> Bedingung</label>
      <label *ngIf="removable" class="btn btn-sm btn-danger" (click)="removeSelf.emit()"><i class="fa fa-trash"></i></label>
    </div>
  </div>

  <div *ngFor="let child of group.elements; let i = index" class="mb-2 group-elements">
    <app-workflow-conditions-group
      *ngIf="child.type==='group'"
      [variables]="variables"
      [group]="child"
      [removable]="true"
      (groupChange)="onChildGroupChange(i, $event)"
      (removeSelf)="removeChild(i)"
    ></app-workflow-conditions-group>

    <app-workflow-conditions-row
      *ngIf="child.type==='expression'"
      [variables]="variables"
      [expr]="child"
      (exprChange)="onChildExpressionChange(i, $event)"
      (exprDelete)="removeChild(i)"
    ></app-workflow-conditions-row>
  </div>
</div>


